module.exports = __webpack_public_path__ + "img/member_message_icon_431008.5e54b96e.png";